export enum TripType {
  ROUND_TRIP = 'ROUND_TRIP',
  ONE_WAY = 'ONE_WAY',
  OPEN_JAW = 'OPEN_JAW',
}
